<script setup lang="ts">
  const emit = defineEmits<{
    (e: 'submit'): void,
  }>()
</script>

<template>
  <form @submit.prevent="emit('submit')">
    <div class="flex flex-col gap-4">
      <slot></slot>
    </div>
  </form>
</template>
